import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

// capital-mui-theme v37 gray50 token. Token not available in v36
const muiV37Gray50 = '#F8F8F8';

export const styles = createTypedSxStyles({
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '24px',
    backgroundColor: muiV37Gray50
  },
  dialogContent: {
    minHeight: '500px'
  },
  dialogContentBox: {
    padding: '50px'
  },
  textField: {
    width: '100%'
  },
  titleTextField: {
    width: '100%',
    '&& .no-format:focus': {
      border: `0px solid ${capitalDesignTokens.semanticColors.interaction.focus}`,
      padding: '4px 10px'
    },
    '&& .no-format:hover': {
      border: 'none'
    }
  },
  infoText: {
    maxWidth: '580px',
    marginTop: '-8px', // Move it a bit closer to the fields
    color: capitalDesignTokens.foundations.colors.gray700
  },
  dialogActions: {
    padding: '24px',
    backgroundColor: muiV37Gray50
  },
  actionButton: {
    minWidth: '80px'
  },
  loadingSkeleton: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
  },
  loadingIcon: {
    color: capitalDesignTokens.foundations.colors.white,
    marginLeft: '8px'
  },
  customReportsLink: {
    color: capitalDesignTokens.semanticColors.interaction.focus,
    textDecoration: 'underline',
    cursor: 'pointer'
  }
});
